import { toArray } from '@wix/wow-utils';
const name = 'BaseClip';
const properties = {};
function getClipRect(compRect, contentRect) {
    const top = contentRect.top - compRect.top;
    const left = contentRect.left - compRect.left;
    const right = contentRect.width + left;
    const bottom = contentRect.height + top;
    return `rect(${[top, right, bottom, left].join('px,')}px)`;
}
function animate(kit, elements, duration = 0, delay = 0, { to = {}, from = {}, ...params } = {}) {
    elements = toArray(elements);
    const compRect = kit.engine.getBoundingRect(elements[0]);
    const contentRect = kit.engine.getBoundingContentRect(elements[0]);
    const initialRect = getClipRect(compRect, contentRect);
    if (!to.clip) {
        to.clip = initialRect;
    }
    if (!from.clip) {
        from.clip = initialRect;
    }
    return kit.engine.tween(elements, { duration, delay, from, to, ...params }, [
        'clip',
    ]);
}
export { name, properties, animate };
//# sourceMappingURL=baseClip.js.map